import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * Rótulos do paginador do Material em português.
 *
 * O `MatPaginatorIntl` padrão é em inglês e vaza para a tela em todas as listas do sistema
 * ("Items per page", "1 – 10 of 21"). Como é um serviço injetável, uma única substituição no
 * {@link appConfig} atende os dois módulos e todas as telas de resultado — não há nada a fazer
 * componente a componente.
 */
export function paginadorEmPortugues(): MatPaginatorIntl {
  const intl = new MatPaginatorIntl();

  intl.itemsPerPageLabel = 'Itens por página:';
  intl.nextPageLabel = 'Próxima página';
  intl.previousPageLabel = 'Página anterior';
  intl.firstPageLabel = 'Primeira página';
  intl.lastPageLabel = 'Última página';
  intl.getRangeLabel = intervalo;

  return intl;
}

/**
 * "11 – 20 de 73". O cálculo do fim replica o do Material: a última página costuma ter menos
 * itens que o tamanho da página, e mostrar "71 – 80 de 73" seria pior do que não mostrar nada.
 */
function intervalo(pagina: number, tamanhoPagina: number, total: number): string {
  if (total === 0 || tamanhoPagina === 0) {
    return `0 de ${total}`;
  }
  const inicio = pagina * tamanhoPagina;
  const fim = inicio < total
    ? Math.min(inicio + tamanhoPagina, total)
    : inicio + tamanhoPagina;
  return `${inicio + 1} – ${fim} de ${total}`;
}
